import template from 'core/service/pdf-generation/products/term-life/template'
import { section } from 'core/service/pdf-generation/products/term-life/sections'
import { commonSection } from 'core/service/pdf-generation/products/common/sections'
import { createPdfDocument } from 'core/service/pdf-generation/document-creation'
import { createCommonPdf } from '../common/pdf-document'
import { basicPlanDetailsLabelFn } from 'core/service/pdf-generation/products/term-life/sections/product-benefit-section'
import VALUES from 'core/data-model/constants/values'

export const createFullBIDocDefinition = async (props) => {
  const pdfTemplate = await template({ ...props, biType: props.biType })
  const paymentChannels = await commonSection.paymentChannels(props)

  const findContentByProduct = (productCode) => {
    switch (productCode) {
      case VALUES.LIFE_SUPER_SAVE_14_5_CODE:
      case VALUES.LIFE_ULTRA_SAVE_10_3_CODE:
        return [
          ...commonSection.profile(props),
          ...commonSection.productBenefits({
            ...props,
            basicPlanDetailsLabelFn,
          }),
          ...commonSection.riders(props),
          section.basicPlanConditionGIO(),
          ...commonSection.policyGioValueTable(props),
          { text: '', pageBreak: 'after' },
          commonSection.taxGioDeductionBenefit(props),
          commonSection.legalDisclaimerMarketConductNoAddtionalContract(props),
          paymentChannels,
          commonSection.signature(props),
        ]
      case VALUES.ISMART_80_6:
        return [
          section.profileSnapshot(props),
          section.basicPlanBenefit({
            ...props,
            basicPlanDetailsLabelFn,
          }),
          ...commonSection.riders(props),
          section.basicPlanConditionISmart(),
          ...section.iSmartPolicyValueTable(props),
          { text: '', pageBreak: 'after' },
          commonSection.taxConsentDeductionBenefit(props),
          commonSection.legalDisclaimerMarketConduct(props),
          paymentChannels,
          commonSection.signature(props),
        ]
      case VALUES.GLOBAL_INDEX_16_6_CODE.JUNIOR:
      case VALUES.GLOBAL_INDEX_16_6_CODE.SENIOR:
      case VALUES.INDEX_LINKED_25_5_CODE.JUNIOR:
      case VALUES.INDEX_LINKED_25_5_CODE.SENIOR:
      case VALUES.INDEX_LINKED_15_8_CODE.JUNIOR:
      case VALUES.INDEX_LINKED_15_8_CODE.SENIOR:
        return [
          ...commonSection.profile(props),
          ...commonSection.productBenefits({
            ...props,
            basicPlanDetailsLabelFn,
          }),
          section.basicPlanConditionISmart(),
          section.policyValueTableExample(1, VALUES.GLOBAL_INDEX_16_6_VALUE_INDEX_GROWTH[0], props),
          section.policyValueTableExample(2, VALUES.GLOBAL_INDEX_16_6_VALUE_INDEX_GROWTH[1], props),
          section.policyValueTableExample(3, VALUES.GLOBAL_INDEX_16_6_VALUE_INDEX_GROWTH[2], props),
          section.investmentBenefitTableGlobalIndex(props),
          { text: ' ' },
          commonSection.taxGioDeductionBenefit(props),
          commonSection.legalDisclaimerMarketConductNoAddtionalContract(props),
          paymentChannels,
          commonSection.signature(props),
        ]
      default:
        return [
          ...commonSection.profile(props),
          ...commonSection.productBenefits({
            ...props,
            basicPlanDetailsLabelFn,
          }),
          ...commonSection.riders(props),
          section.basicPlanCondition(),
          ...section.policyValueTable(props),
          section.investmentBenefitTable(props),
          commonSection.taxConsentDeductionBenefit(props),
          commonSection.legalDisclaimerMarketConduct(props),
          paymentChannels,
          commonSection.signature(props),
        ]
    }
  }

  return {
    content: findContentByProduct(props.basicPlan.code),
    ...pdfTemplate,
  }
}

const createFullBIPdf = createPdfDocument(createFullBIDocDefinition)

export const createTermLifePdf = async (props) => {
  return await createCommonPdf(props, createFullBIPdf)
}
